import { useTranslate } from "ra-core";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import type { Priority } from "../types";
import { PRIORITIES } from "./cardModel";

export interface PrioritySelectProps {
  value: Priority;
  onChange: (priority: Priority) => void;
  className?: string;
}

export const PrioritySelect = ({
  value,
  onChange,
  className,
}: PrioritySelectProps) => {
  const translate = useTranslate();
  return (
    <Select value={value} onValueChange={(next) => onChange(next as Priority)}>
      <SelectTrigger
        className={className}
        aria-label={translate("crm.operations.fields.priority")}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {PRIORITIES.map((priority) => (
          <SelectItem key={priority} value={priority}>
            {translate(`crm.operations.priorities.${priority}`)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
